import { render, staticRenderFns } from "./AddCanteen.vue?vue&type=template&id=2f37566f&scoped=true&"
import script from "./AddCanteen.vue?vue&type=script&lang=js&"
export * from "./AddCanteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37566f",
  null
  
)

export default component.exports